import * as React from 'react';
import { FC } from 'react';

import { Chip } from '@rbilabs/components-library';

import { Wrapper } from './th-offer-tag.styled';
import { IThOfferTagProps } from './types';

const ThOfferTag: FC<IThOfferTagProps> = props => {
  return (
    <Wrapper data-testid="offer-tag">
      <Chip {...props} />
    </Wrapper>
  );
};

export default ThOfferTag;
